var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"heading-6 ml-4"},[_vm._v(" Sorry, we couldn't find page. "),_c('div',{staticClass:"mt-5"},[_c('a',{staticClass:"text-decoration-none font-under-normal mr-1",attrs:{"href":"/"}},[_vm._v(" Go to the Dashboard ")]),_vm._v(" instead? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }